var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.ordered).length > 0)?_c('section',{staticClass:"specialisms"},_vm._l((_vm.ordered),function(s,id){return _c('specialism',{key:id,attrs:{"data":s}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }